import { Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip } from "@material-ui/core";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { authStore } from "../../../../auth";
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';
import { companiesAdminStore } from '../../CompaniesAdmin';

const styles = createStyles({
  root: {
    padding: "2rem",
  },
  buttonDiv: {
    marginTop: "1rem",
    justifyContent: "center",
    display: "flex",
  },
  button: {
    height: "128px",
    width: "128px",
    marginRight: "24px",
    marginBottom: "24px",
    border: "1px solid #1f1d1d",
    color: "#efefef",
    borderRadius: "64px",
  },
  textField: {
    display: "flex",
    paddingRight: "24px",
    paddingBottom: '24px'
  },
  companySelect: {
    minWidth: "16.5rem",
  },
  chip: {}
});

@observer
class UserAccount extends React.Component<any> {

  @observable
  public userInfo: any = {
    Phone: '',
    Address: '',
    City: '',
    State: '',
    Zip: ''
  }

  constructor(props: any) {
    super(props);
  }

  protected normalizePhone = (value: string) => {
    return (value || '').replace(/\D/g, '').slice(0, 10);
  }

  protected formatPhone = (value: string) => {
    const digits = this.normalizePhone(value);
    if (digits.length <= 3) {
      return digits;
    }
    if (digits.length <= 6) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    }
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  public componentDidMount = async () => {
    if (!companiesAdminStore.all_companies) {
      await companiesAdminStore.retrieveCompanies()
    }
    if (!companiesAdminStore.all_sites) {
      await companiesAdminStore.getSitesList()
    }
    //D-011 getDistributorList function call here
    if (!companiesAdminStore.all_distributor) {
      await companiesAdminStore.getDistributorList()
    }
    this.userInfo = {
      Phone: this.normalizePhone(authStore.currentUser.Phone),
      Address: authStore.currentUser.Address,
      City: authStore.currentUser.City,
      State: authStore.currentUser.State,
      Zip: authStore.currentUser.Zip,
    }
  }

  public saveDisabled = () => {
    if (
      this.userInfo.Phone !== authStore.currentUser.Phone ||
      this.userInfo.Address !== authStore.currentUser.Address ||
      this.userInfo.City !== authStore.currentUser.City ||
      this.userInfo.State !== authStore.currentUser.State ||
      this.userInfo.Zip !== authStore.currentUser.Zip 
      ) {
      return false
    }
    return true
  }

  public getCompanyChipInfo = (company_id: number) => {
    const company = companiesAdminStore.all_companies.find((c: any) => c.company_id === company_id);
    if (!company) {
      return 'none'
    }
    return (
      <React.Fragment>
        <b>{company.CompanyName}</b>
      </React.Fragment>
    )
  }

  public getSiteChipInfo = (site_id: number) => {
    const site = companiesAdminStore.all_sites.filter((s: any) => s.site_id === site_id)[0];
    if (!site) {
      return 'none'
    }
    return (
      <React.Fragment>
        <b>{site.displayName}</b> <span style={{marginLeft: '5px'}}> ({site.CompanyName})</span>
      </React.Fragment>
    )
  }

  public render() {
    const { classes } = this.props;

    if (
      !companiesAdminStore.all_companies ||
      !companiesAdminStore.all_sites
    ) {
      return <div>loading</div>
    }
    return (
      <Grid container={true} className={classes.root}>
        <Grid item={true} xs={6}>
          <TextField
            label="First Name"
            classes={{ root: classes.textField }}
            value={authStore.currentUser.FirstName}
            InputLabelProps={{ shrink: true }}
            disabled={true}
          />
        </Grid>
        <Grid item={true} xs={6}>
          <TextField
            label="Last Name"
            classes={{ root: classes.textField }}
            value={authStore.currentUser.LastName}
            InputLabelProps={{ shrink: true }}
            disabled={true}
          />
        </Grid>
        <Grid item={true} xs={6}>
          <TextField
            label="Email"
            classes={{ root: classes.textField }}
            value={authStore.currentUser.Email}
            InputLabelProps={{ shrink: true }}
            disabled={true}
          />
        </Grid>
        <Grid item={true} xs={6}>
          <TextField
            label="Phone"
            classes={{ root: classes.textField }}
            value={this.formatPhone(this.userInfo.Phone)}
            InputLabelProps={{ shrink: true }}
            // disabled={true}
            onChange={this.handlePhoneInput}
          />
        </Grid>
        <Grid item={true} xs={6}>
          <TextField
            label="Address"
            classes={{ root: classes.textField }}
            value={this.userInfo.Address}
            InputLabelProps={{ shrink: true }}
            // disabled={true}
            // tslint:disable-next-line: jsx-no-lambda
            onChange={this.handleInput('Address')}
          />
        </Grid>
        <Grid item={true} xs={6}>
          <TextField
            label="City"
            classes={{ root: classes.textField }}
            value={this.userInfo.City}
            InputLabelProps={{ shrink: true }}
            // disabled={true}
            onChange={this.handleInput('City')}
          />
        </Grid>
        <Grid item={true} xs={6}>
          <TextField
            label="State"
            classes={{ root: classes.textField }}
            value={this.userInfo.State}
            InputLabelProps={{ shrink: true }}
            // disabled={true}
            onChange={this.handleInput('State')}
          />
        </Grid>
        <Grid item={true} xs={6}>
          <TextField
            label="Zip"
            classes={{ root: classes.textField }}
            value={this.userInfo.Zip}
            InputLabelProps={{ shrink: true }}
            // disabled={true}
            onChange={this.handleInput('Zip')}
          />
        </Grid>
        <Grid item={true} xs={6}>
          <FormControl>
            <InputLabel htmlFor={"user_company"} shrink={true}>
              Company
            </InputLabel>
            <Select
              open={false}
              multiple={true}
              inputProps={{
                name: "user_company",
                id: "user_company",
              }}
              value={authStore.currentUser.Companies.map((c: any) => c.company_id)}
              classes={{ root: classes.companySelect }}
              disabled={true}
              // tslint:disable-next-line: jsx-no-lambda
              renderValue={(selected: any) => {
                return (
                  <div style={{ whiteSpace: 'normal' }}>
                    {selected.map((c: any) => (
                      <Chip style={{ marginTop: '3px' }} key={c} label={this.getCompanyChipInfo(c)} className={classes.chip} />
                    ))}
                  </div>
                )
              }
              }
            />
          </FormControl>
        </Grid>
        <Grid item={true} xs={6}>
          {(authStore.currentUser.portal_role_id !== 7 && authStore.currentUser.portal_role_id !== 8 ) ? //D-011 
            <FormControl>
            <InputLabel htmlFor={"user_sites"} shrink={true}>
              Pharmacies
            </InputLabel>
            <Select
              open={false}
              multiple={true}
              inputProps={{
                name: "user_sites",
                id: "user_sites",
              }}
              value={authStore.currentUser.Sites.map((s: any) => s.siteId)}
              classes={{ root: classes.companySelect }}
              disabled={true}
              // tslint:disable-next-line: jsx-no-lambda
              renderValue={(selected: any) => {
                return (
                  <div style={{ whiteSpace: 'normal' }}>
                    {selected.map((c: any) => (
                      <Chip style={{ marginTop: '3px' }} key={c} label={this.getSiteChipInfo(c)} className={classes.chip} />
                    ))}
                  </div>
                )
              }
              }
            />
          </FormControl> : ''}
        </Grid>
        <div style={{ paddingTop: '20px' }}>
          <Button
            variant={'contained'}
            // classes={{ root: classes.submitButton }}
            // tslint:disable-next-line: jsx-no-lambda
            onClick={() => this.props.history.push('/account/password/' + authStore.currentUser.auth_id)}
          >
            Change Password
          </Button>
          <Button
            variant={'contained'}
            disabled={this.saveDisabled()}
            // classes={{ root: classes.submitButton }}
            // tslint:disable-next-line: jsx-no-lambda
            onClick={this.save}
          >
            Save
          </Button>
        </div>
      </Grid>
    );
  }
  @action
  protected handleInput = (property: string) => (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    this.userInfo[property] = e.target.value;
    // validationsStore.runValidator(property, this.props.currentUser[property] = e.target.value)
  };
  
  @action
  protected handlePhoneInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    this.userInfo.Phone = this.normalizePhone(e.target.value);
  };
  @action
  protected save = async () => {
    await authStore.saveUserProfile(authStore.currentUser.auth_id, this.userInfo);
    // validationsStore.runValidator(property, this.props.currentUser[property] = e.target.value)
  };
}

export default withStyles(styles, { withTheme: true })(
  withRouter(UserAccount)
);


// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/components/UserAccount.tsx